import React from "react";
import { ORDER_TABS } from "../../../util/constants";

/**
 * DatesTab Component
 * Displays and manages the Dates tab content
 * Handles date fields with validation for date relationships and formats
 */
const DatesTab = ({
  currentTabFields,
  isEditing,
  fieldValues,
  errorFieldArray,
  fieldValidationErrors,
  renderFieldInput,
  hasValidationError,
  getValidationErrorMessage,
}) => {
  if (currentTabFields.length === 0) {
    return (
      <div className="orders-empty-state">
        <p>No fields available for Dates.</p>
      </div>
    );
  }

  return (
    <div
      className={`details-grid ${!isEditing ? "view-mode" : ""}`}
      key={ORDER_TABS.DATES}
    >
      {currentTabFields.map((field, index) => (
        <div
          key={`${ORDER_TABS.DATES}-${field.field}-${index}`}
          className={`details-item ${
            errorFieldArray.includes(field.fieldStateKey) ? "has-error" : ""
          }`}
        >
          <div className="label">{field.labelToShowOnUI}</div>
          <div className="field-container">
            {renderFieldInput(field)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DatesTab;
